import { CategoryAttributeModel } from '../../../../server/mpsklad_core/Models/MpCard/CategoryAttributeModel'

export const getAttributeDiffMap = (formAttrs: CategoryAttributeModel[],
                                    mpAttrs: CategoryAttributeModel[]): Map<string, string> => {
  const map = new Map<string, string>()

  for (const attr of formAttrs) {
    const mpAttr = mpAttrs.find(a => a.id === attr.id)
    if (mpAttr && attr.currentValue !== mpAttr.currentValue) {
      map.set(attr.id, attr.currentValue)
    }
  }

  return map
}